import { SubscriptionLike } from 'rxjs';

export interface Disposable {
  dispose: () => void;
}

export type DisposableLike = Disposable | SubscriptionLike | null | undefined;

/**
 * Safely attempts to dispose or unsubscribe from an object if it exists
 * If the item is an array it will try to dispose all items in that array
 * @param item A disposable like object that could directly implement a dispose function or provide an unsubscribe function
 */
export function tryDispose(item: DisposableLike | DisposableLike[]): void {

  if (Array.isArray(item)) {
    item.forEach(d => tryDispose(d));
  } else if (item) {
    if ('unsubscribe' in item) {
      item.unsubscribe();
    } else {
      item.dispose();
    }
  }
}
